import { Stack } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { useRdContext } from '@neo.tax/rd/context';
import { useRdProjectTeamMembers, RdProject } from '@neo.tax/rd/hooks';
import { useCurrentUserScopeForCurrentCompany, useKeywordSearch, ProjectTeamMembersTable } from '@neo.tax/shared';

import { RdProjectTeamMembersToolbar } from '../rd-project-team-members-toolbar';
import { useRdTeamMembersTableColumns } from './hooks';

interface RdProjectTeamMembersProps {
  rdProject: RdProject;
}

export const RdProjectTeamMembers = ({ rdProject }: RdProjectTeamMembersProps): ReactElement => {
  const { searchKeyword, setSearchKeyword } = useKeywordSearch();
  const { fiscalYearId, periodName } = useRdContext();
  const { isPiiRedacted } = useCurrentUserScopeForCurrentCompany();

  const {
    fetchMore,
    isLoadingMore,
    loading: loadingTeamMembers,
    rdProjectTeamMembers: teamMembers,
  } = useRdProjectTeamMembers({
    rdProjectId: rdProject.id,
    fiscalYearId,
    periodName,
    searchKeyword,
    hasAllocation: true,
    debounceKey: 'GET_PROJECT_TEAM_MEMBERS_WITH_ALLOCATIONS_KEY',
    numElementsPerFetch: 30,
  });
  const { columns } = useRdTeamMembersTableColumns({
    rdProject,
    teamMembers,
  });

  return (
    <Stack direction="column" fullHeight>
      {isPiiRedacted ? (
        <></>
      ) : (
        <RdProjectTeamMembersToolbar
          rdProject={rdProject}
          searchKeyword={searchKeyword}
          setSearchKeyword={setSearchKeyword}
        />
      )}
      <ProjectTeamMembersTable
        columns={columns}
        teamMembers={teamMembers}
        endReached={fetchMore}
        loadingRows={loadingTeamMembers}
        loadingFooter={isLoadingMore}
      />
    </Stack>
  );
};
